import {
    Button,
    Grid,
    LinearProgress,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import React, { useContext, useEffect, useState } from 'react';
import AiTrainingDataContext from '../../AiTrainingDataContext';
import { makeStyles } from '@mui/styles';
import TruncatedTextDisplay from '../../../components/common/TruncatedTextDisplay';
import { useNavigate } from 'react-router';
//import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiDataGrid-columnHeaderTitleContainer': {
            padding: 0,
            margin: 0,
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            overflow: 'none',
        },
        '& .MuiDataGrid-iconButtonContainer': {
            padding: 0,
            margin: 0,
        },
        '& .MuiIconButton-root': {
            padding: 0,
            margin: 0,
        },
    },
}));

function CustomLoadingOverlay() {
    return (
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
            </div>
        </GridOverlay>
    );
}

function SimulationJobResults(props) {
    const { test } = props;
    const classes = useStyles();
    const [pageSize, setPageSize] = useState(10);
    const navigate = useNavigate();

    const {
        simResultsLoading,
        setSimResultsLoading,
        fetchSimulationJobResults,
        simulationJobResults,
        restauId,
        setSelectedSimJob,
    } = useContext(AiTrainingDataContext);

    const rowHeight = 50;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs')); // or 'md'

    const columns = [
        {
            field: 'jobId',
            type: 'string',
            description: '',
            headerName: 'Job Id',
            flex: 0.6,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'status',
            type: 'string',
            description: '',
            headerName: 'Job Status',
            flex: 0.3,
            headerAlign: 'center',
            align: 'center',
            // renderCell: (params) => {
            //     return params.row.numberOfRecordings ===
            //         params.row.processedRecordings
            //         ? 'Completed'
            //         : 'In Progress';
            // },
        },
        {
            field: 'summarizationPromptToUse',
            type: 'string',
            description: '',
            headerName: 'Prompt Used',
            flex: 1.2,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return (
                    params.row.summarizationPromptToUse && (
                        <TruncatedTextDisplay
                            text={params.row.summarizationPromptToUse}
                            maxLength={isSmallScreen ? 30 : 90}
                            popOverMaxWidth={'70%'}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                        />
                    )
                );
            },
        },
        {
            field: 'orderErrorRate',
            type: 'number',
            description: '',
            headerName: 'Order Error Rate (%)',
            flex: 0.3,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return params.row.orderErrorRate * 100;
            },
        },
        {
            field: 'itemErrorRate',
            type: 'number',
            description: '',
            headerName: 'Item Error Rate (%)',
            flex: 0.3,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return params.row.itemErrorRate * 100;
            },
        },
        {
            field: 'details',
            type: 'string',
            description: '',
            headerName: 'Details',
            flex: 0.2,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return (
                    <Button
                        //sx={{ width: 10 }}
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            showSimulationDetailedStats(params.row.id);
                        }}
                    >
                        >>
                    </Button>
                );
            },
        },
    ];

    const showSimulationDetailedStats = (jobId) => {
        //debugger;
        // setSelectedSimJob((prevVal) =>
        //     simulationJobResults.find((x) => x.jobId === jobId)
        // );
        navigate(`/aitrainingData/simulationResults/${jobId}`);
    };

    const loadData = async () => {
        setSimResultsLoading(true);
        await fetchSimulationJobResults();
        setSimResultsLoading(false);
    };

    useEffect(() => {
        //debugger;
        if (!restauId) return;

        // Fetch data and set loading state
        loadData();
    }, [restauId]);

    return (
        <Grid item xs={12}>
            <DataGrid
                className={classes.root}
                rows={simulationJobResults}
                columns={columns}
                autoHeight={true}
                loading={simResultsLoading}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20, 50]}
                pagination
                components={{
                    LoadingOverlay: CustomLoadingOverlay,
                }}
                rowHeight={rowHeight}
            />
        </Grid>
    );
}

SimulationJobResults.propTypes = {};

export default SimulationJobResults;
